import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/graphics/obj/graph-10.svg")